var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"logoutBtn",on:{"click":_vm.onLogout}},[_vm._t("default",function(){return [_vm._v("退出登录")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }